"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reclaimROICalculator = void 0;
const consts_1 = require("../consts");
const reclaimROICalculator = (teamSize, averageSalary, costPerMonth) => {
    const hoursWorkedPerMonthPerPerson = consts_1.HOURS_WORKED_PER_WEEK_PER_PERSON * consts_1.WEEKS_WORKED_PER_MONTH_PER_PERSON;
    const hoursWorkedPerYearPerPerson = consts_1.HOURS_WORKED_PER_WEEK_PER_PERSON * consts_1.WEEKS_WORKED_PER_YEAR_PER_PERSON;
    const totalSavedFrac = consts_1.SAVED_TASK_WORK_FRAC + consts_1.SAVED_MEETINGS_FRAC;
    const hoursWorkedPerMonth = teamSize * hoursWorkedPerMonthPerPerson;
    const costPerPersonPerHour = averageSalary / hoursWorkedPerYearPerPerson;
    const hoursSavedPerMonth = hoursWorkedPerMonth * totalSavedFrac;
    const moneySavedPerMonth = hoursSavedPerMonth * costPerPersonPerHour;
    const totalROIPerMonth = moneySavedPerMonth - costPerMonth;
    return {
        hoursSavedPerMonth,
        moneySavedPerMonth,
        totalROIPerMonth,
    };
};
exports.reclaimROICalculator = reclaimROICalculator;
